export const PAGES_V2_SET = 'PAGES_V2_SET';
export const PAGES_V2_SET_MULTIPLE = 'PAGES_V2_SET_MULTIPLE';

export const setV2 = (page, key, value) => ({
    type: PAGES_V2_SET,
    payload: { page, key, value },
});
